<template>
    <Head title="QM - Listagem de encomendas"/>
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-4xl text-white leading-tight lobster">
                Encomendas
            </h2>
        </template>

        <div class="py-2 flex flex-wrap justify-center">
            <div class="w-11/12 sm:px-6 lg:px-8">
                <div class="overflow-hidden shadow-sm rounded-lg">
                    <div class="bg-slate-100 border-b border-slate-400">
                        <div id="app" class="relative">
                            <div id="loader"
                                 class="fixed w-full h-full left-0 top-0 flex justify-center content-center flex-wrap z-10 bg-slate-900/75"
                                 :class="{hidden: loaderHidden}">
                                <div class="py-5 bg-white rounded-lg text-center" style="opacity: 0.8;">
                                    <img class="inline-block" src="/storage/img/loader.gif"/>
                                </div>
                            </div>
                            <keep-alive>
                                <component
                                    :key="myKey"
                                    :is="currentTab"
                                    v-bind="compProps"
                                    @do-reserve="doReserve" @mark-as="markAs" @change-status="changeStatus"
                                    @go-back="goBack" @validar="validar" @payment="checkPayment"
                                ></component>
                            </keep-alive>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import {Head} from '@inertiajs/inertia-vue3';
import Table from '@/Components/Order/Table.vue';
import Validations from '@/Components/Order/Validations.vue';
import Payment from '@/Components/Payment.vue';
import {Inertia} from "@inertiajs/inertia";
import Swal from "sweetalert2";
import {computed, onMounted, reactive, ref, watch} from 'vue';

export default {
    components: {
        BreezeAuthenticatedLayout,
        Head,
        Table,
        Validations,
        Payment
    },
    props: ['total', 'orders', 'site_url', 'article_codes', 'statuses', 'filters', 'user', 'checked_in'],
    emails: [],
    phones: [],
    setup(props) {
        const page = computed(() => props.filters.offset === 0 ? 1 : props.filters.offset / props.filters.limit + 1);
        const myKey = ref(0);
        const loaderHidden = ref(true);
        const currentTab = ref('Table')

        const isReSearch = ref(true);
        onMounted(() => {
            isReSearch.value = false;
            if(props.checked_in) {
                validar(props.checked_in);
            }
        })

        const myOrder = ref({});

        function doReserve(event) {
            const id = event.target.id;
            const checked = event.target.checked;
            loaderHidden.value = false;

            axios.patch('/orders/reserved/' + id, {
                "value": checked
            }).then(response => {
                loaderHidden.value = true;
            })
                .catch(function (error) {
                    Swal.fire('Erro, por favor tente mais tarde!', '', 'error')
                });
        }

        function markAs(data) {
            loaderHidden.value = false;

            if (data.deleteOnly) {
                const dateObj = new Date(data.data.value.created_at);
                let month = dateObj.getUTCMonth() + 1;
                if (month < 10) {
                    month = '0' + month;
                }
                const day = dateObj.getUTCDate();
                const year = dateObj.getUTCFullYear();
                const newdate = day + "/" + month + "/" + year;

                let total = 0;
                let total_qty = 0;

                total_qty = data.data.value.order_line.reduce((acc, v) => acc + parseInt(v.qtd, 10), 0);

                data.data.value.order_line.forEach((el) => {
                    total = Math.round((parseFloat(el.article.price) * parseInt(el.qtd, 10) + total + Number.EPSILON) * 100) / 100
                });
                loaderHidden.value = true;
                return Swal.fire({
                    title: '<strong class="lobster">Tens a certeza?</strong>',
                    icon: 'question',
                    html:
                        'Com esta ação vai eliminar a encomenda nr ' + data.data.value.id + ' feita pelo(a) ' + data.data.value.name + ' no dia ' + newdate + '<br/><table class="mx-auto w-3/4 mt-5"><tr><td class="px-6 text-sm text-gray-500">Estado: </td><td class="px-6 text-sm text-gray-500 text-left">' + data.data.value.status.name + '</td></tr><tr><td class="px-6 text-sm text-gray-500">Artigos: </td><td class="px-6 text-sm text-gray-500 text-left">' + data.data.value.order_line.length + '</td></tr><tr><td class="px-6 text-sm text-gray-500">Peças: </td><td class="px-6 text-sm text-gray-500 text-left">' + total_qty + '</td></tr><tr><td class="px-6 text-sm text-gray-500">Total: </td><td class="px-6 text-sm text-gray-500 text-left">' + total + '</td></tr></table>',
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText:
                        '<i class="fa fa-thumbs-up"></i> Força',
                    confirmButtonAriaLabel: 'Thumbs up, great!',
                    cancelButtonText:
                        '<i class="fa fa-thumbs-down"></i> Esquece',
                    cancelButtonAriaLabel: 'Thumbs down'
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        loaderHidden.value = false;
                        axios.delete('/orders/' + data.data.value.id, {})
                            .then(response => {
                                Inertia.get(window.location.href, {}, {
                                    preserveState: true,
                                    preserveScroll: true,
                                    onFinish: response => {
                                        myKey.value++;
                                        loaderHidden.value = true;
                                    }
                                });
                            })
                            .catch(function (error) {
                                Swal.fire('Erro, por favor tente mais tarde!', '', 'error')
                            });

                    } else if (result.isDenied) {
                        Swal.fire('Changes are not saved', '', 'info')
                    }
                })

            }
            const handleSend = (adresses) => {
                loaderHidden.value = true;

                return Swal.fire({
                    title: '<strong class="lobster">Tracking Number</strong>',
                    icon: 'question',
                    input: 'text',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    html:
                        'Introduz o tracking number da encomenda nr ' + data.data.value.id + ' feita pelo(a) ' + data.data.value.name,
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText:
                        'OK',
                    confirmButtonAriaLabel: 'OK',
                    cancelButtonText:
                        'Cancelar',
                    cancelButtonAriaLabel: 'Cancelar',
                    showLoaderOnConfirm: true,
                    preConfirm: (tracking_number) => {
                        return Inertia.patch('/orders/list/' + currentStatus.value, {
                            status: 5,
                            tracking_number: tracking_number,
                            filters: props.filters,
                            status_list: currentStatus.value,
                            id: data.data.value.id
                        }, {
                            preserveState: true,
                            onBefore: () => {
                                loaderHidden.value = false;
                            },
                            onSuccess: (result) => {
                                page.value = result.props.filters.offset === 0 ? 1 : result.props.filters.offset / result.props.filters.limit + 1;
                                myKey.value++;
                                loaderHidden.value = true;
                                let printWindow = window.open();
                                printWindow.document.open('text/plain')
                                printWindow.document.write(adresses.from + '<br/>' + adresses.address + '<br/>' + adresses.country);
                                printWindow.document.close();
                                printWindow.focus();
                                printWindow.print();
                                printWindow.close();
                            },
                            onError: () => {
                                Swal.showValidationMessage(
                                    `Erro: ${error}`
                                )
                            }
                        })
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    backdrop: true
                })
            };
            const handlePayUnDelete = (status) => {
                return Inertia.patch('/orders/list/' + currentStatus.value, {
                    status: status,
                    filters: props.filters,
                    status_list: currentStatus.value,
                    id: data.data.value.id
                }, {
                    preserveState: true,
                    onBefore: () => {
                        loaderHidden.value = false;
                    },
                    onSuccess: (result) => {
                        page.value = result.props.filters.offset === 0 ? 1 : result.props.filters.offset / result.props.filters.limit + 1;
                        myKey.value++;
                        loaderHidden.value = true;
                    },
                    onError: () => {
                        Swal.showValidationMessage(
                            `Erro: ${error}`
                        )
                    }
                })
            };

            if (data.data.value.deleted_at) {
                return handlePayUnDelete(6);
            } else if (parseInt(data.data.value.status_id, 10) === 4) {
                return handleSend({
                    from: data.data.value.name,
                    address: data.data.value.address,
                    country: data.data.value.country
                })
            } else if (parseInt(data.data.value.status_id, 10) === 3) {
                return handlePayUnDelete(4);
            }
        }

        const currentStatus = ref(decodeURIComponent(window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1)));

        const columns = ref([
            {
                label: 'Nr',
                field: 'id',
                value: true,
                width: "7%",
                sortable: true,
                isKey: true,
            },
            {
                label: 'Nome',
                field: 'name',
                value: true,
                width: "10%",
                sortable: true,
                isKey: false,
            },
            {
                label: 'Nome Comprador',
                field: 'buyer_name',
                value: false,
                width: "16%",
                sortable: true,
                isKey: false,
            },
            {
                label: 'País',
                field: 'country',
                value: true,
                width: "10%",
                sortable: true,
                isKey: false
            },
            {
                label: 'URL',
                field: 'token',
                value: true,
                width: "10%",
                sortable: true,
                isKey: false
            },
            {
                label: 'Nr Peças',
                field: 'articles',
                value: false,
                width: "7%",
                sortable: true,
                isKey: false
            },
            {
                label: 'Estado',
                field: 'status',
                value: true,
                width: "10%",
                sortable: false,
                isKey: false
            },
            {
                label: 'Data Criação',
                field: 'created_at',
                value: true,
                width: "7%",
                sortable: true,
                isKey: false
            },
            {
                label: 'Pagamento',
                field: 'payment_id',
                value: false,
                width: "8%",
                sortable: true,
                isKey: false
            },
            {
                label: 'Total',
                right: true,
                field: 'total_with_discounts',
                value: true,
                width: "10%",
                sortable: false,
                isKey: false
            },
            {
                label: 'Levantamento',
                field: 'pickup_type',
                value: false,
                width: "8%",
                sortable: true,
                isKey: false
            },
            {
                label: "",
                field: "dismiss",
                value: true,
                width: "1%",
                sortable: false,
                isKey: false
            },
            {
                label: "",
                field: "validate",
                value: true,
                width: "1%",
                sortable: false,
                isKey: false
            },
            {
                label: "",
                field: "mark_as",
                value: true,
                width: "10%",
                sortable: false,
                isKey: false
            }
        ]);

        function checkStatus() {
            const status = parseInt(currentStatus.value, 10);
            columns.value[columns.value.length - 1].value = false;
            if ([5, 6].indexOf(status) !== -1) {
                if (parseInt(currentStatus.value, 10) === 5)
                    columns.value.splice(11, 1)
            }
            if ([6].indexOf(status) !== -1) {
                columns.value[columns.value.length - 1].value = true;
            }
        }

        checkStatus();

        watch(() => currentStatus.value,
            () => checkStatus());

        function changeStatus(event) {
            loaderHidden.value = false;
            currentStatus.value = event.target.value;
            Inertia.get('/orders/list/' + event.target.value, {
                order: props.filters.order,
                sort: props.filters.sort,
                search: props.filters.search && props.filters.search.length > 0 ? props.filters.search : null,
                onlyMissingArticles: onlyMissingArticles.value,
                onlyStorePickup: onlyStorePickup.value,
            }, {
                onSuccess: page => {
                    loaderHidden.value = true;
                    myKey.value++;
                },
                preserveState: true
            });
        }


        function goBack(reload) {
            if (reload)
                Inertia.get(window.location.pathname + window.location.search);
            else {
                currentTab.value = "Table";
                myOrder.value = {};
                myKey.value++;
            }
        }

        function checkPayment(id, table) {
            loaderHidden.value = false;
            axios.get(props.site_url + '/orders/payments/' + table + '/' + id, {})
                .then(response => {
                    myOrder.value = {
                        payment: response.data.payment,
                        account: response.data.account
                    };
                    console.log(myOrder)
                    currentTab.value = response.data.currentTabs;
                    myKey.value++;
                    loaderHidden.value = true;
                })
                .catch(function (error) {
                    Swal.fire('Erro, por favor tente mais tarde!', '', 'error')
                });
        }

        function validar(o) {
            loaderHidden.value = false;
            axios.get(props.site_url + '/orders/info/' + o.id, {})
                .then(response => {
                    myOrder.value = JSON.parse(JSON.stringify(response.data));
                    currentTab.value = "Validations";
                    myKey.value++;
                    loaderHidden.value = true;
                })
                .catch(function (error) {
                    Swal.fire('Erro, por favor tente mais tarde!', '', 'error')
                });
        }

        const onlyMissingArticles = ref(props.filters.onlyMissingArticles);
        const onlyStorePickup = ref(props.filters.onlyStorePickup);

        const compProps = computed(() => {
            if (currentTab.value === 'Table') {
                return {
                    has_checkbox: false,
                    columns: columns,
                    statuses: props.statuses,
                    page: page,
                    isReSearch: isReSearch,
                    rows: props.orders,
                    total: props.total,
                    ordersTable: true,
                    site_url: props.site_url,
                    onlyMissingArticles: onlyMissingArticles,
                    onlyStorePickup: onlyStorePickup
                };
            } else if (currentTab.value === 'Validations') {
                return {
                    order: myOrder,
                    filters: props.filters,
                    article_codes: props.article_codes,
                    user: props.user,
                    currentStatus: currentStatus.value
                };
            } else if (currentTab.value === 'Payment') {
                return {
                    order: myOrder
                };
            }
        });

        watch(() => onlyMissingArticles.value,
            () => {
            loaderHidden.value = false;
                Inertia.get(window.location.pathname, {
                    offset: props.filters.offset,
                    limit: props.filters.limit,
                    order: props.filters.order,
                    sort: props.filters.sort,
                    search: props.filters.search && props.filters.search.length > 0 ? props.filters.search : null,
                    onlyMissingArticles: onlyMissingArticles.value,
                    onlyStorePickup: onlyStorePickup.value
                }, {
                    preserveState: false,
                    preserveScroll: true,
                    onBefore: function () {
                    },
                    onSuccess: function (aa) {
                        // table.rows = getRows(props.rows);
                        // table.totalRecordCount = props.total;
                        loaderHidden.value = true;
                    }
                })
            });
        watch(() => onlyStorePickup.value,
            () => {
            loaderHidden.value = false;
                Inertia.get(window.location.pathname, {
                    offset: props.filters.offset,
                    limit: props.filters.limit,
                    order: props.filters.order,
                    sort: props.filters.sort,
                    search: props.filters.search && props.filters.search.length > 0 ? props.filters.search : null,
                    onlyMissingArticles: onlyMissingArticles.value,
                    onlyStorePickup: onlyStorePickup.value
                }, {
                    preserveState: false,
                    preserveScroll: true,
                    onBefore: function () {
                    },
                    onSuccess: function (aa) {
                        // table.rows = getRows(props.rows);
                        // table.totalRecordCount = props.total;
                        loaderHidden.value = true;
                    }
                })
            });

        return {
            myKey,
            changeStatus,
            markAs,
            doReserve,
            loaderHidden,
            page,
            isReSearch,
            currentTab,
            validar,
            goBack,
            checkPayment,
            myOrder,
            columns,
            compProps,
            onlyMissingArticles,
            onlyStorePickup
        }
    }
}
</script>
